module.exports = __webpack_public_path__ + "static/media/24-hour-service-blue.9a639813.ico";